export { default } from "./src/templates-search-bar";
